// not implemented
var WorkerClient;
WorkerClient = function() {
    this.attachToDocument = function() {};
    this.on = function() {};
    this.terminate = function() {};
};

exports.WorkerClient = WorkerClient;
